import React from "react";

const RotatingIcons = () => {
    return (
        <div style={{ textAlign: "center" }}>
            <img
                className="margin-t-xl"
                src={require("../../../../img/auth/noun_project_logo@2x.png")}
                width="127"
                height="50"
            />

            <div
                className="rotating-icons-container margin-t-l"
                style={{
                    width: "100%",
                    height: "200px",
                    overflow: "hidden",
                    position: "relative"
                }}
            >
                <style>{`
                            .rotating-icons-container::before{
                                content: '';
                                height: 100%;
                                position: absolute;
                                left: 0;
                                top: 0;
                                width: 50px;
                                background: linear-gradient(to right, rgba(0,0,0,1), rgba(0,0,0,0));
                                z-index: 1;
                            }
                            .rotating-icons-container::after{
                                content: '';
                                height: 100%;
                                position: absolute;
                                right: 0;
                                top: 0;
                                width: 50px;
                                background: linear-gradient(to right, rgba(0,0,0,0), rgba(0,0,0,1));
                            }
                        `}</style>
                <h1
                    className="font-medium weight-medium"
                    style={{
                        position: "absolute",
                        bottom: "24px",
                        left: "50%",
                        transform: "translateX(-50%)"
                    }}
                ></h1>
                <img
                    src={require("../../../../img/auth/rotating_icons@2x.png")}
                    style={{
                        width: "600px",
                        height: "600px",
                        position: "absolute",
                        pointerEvents: "none",
                        animation:
                            "spin-continuous-centered 120s infinite linear"
                    }}
                />
            </div>
        </div>
    );
};

export default RotatingIcons;
